(function () {
    angular.module('tmx-app').factory('VisitReportService', ['$http', 'APP_CONSTANTS', 'tmxResource', '$filter', '$q', 'tmxUtility', '$mdMedia', 'lookupService',
        function ($http, APP_CONSTANTS, tmxResource, $filter, $q, tmxUtility, $mdMedia, lookupService) {

            var Report = tmxResource("report");
            // Report.GetProductSkuByWarehouse = GetProductSkuByWarehouse;
            // Report.GetProductSkuByWarehouseId = GetProductSkuByWarehouseId;
            // Report.setLookups = setLookups;
            Report.exportVisitReport = exportVisitReport;

            function exportVisitReport(fromdate,todate) {
               
                if(!fromdate){
                    fromdate=null;
                }

                if(!todate){
                    todate=null;
                }

                var objArgs = {
                    "FromDate":fromdate,
                    "ToDate":todate
                };

                var filters = {
                    "StoredProcedure": "sp_visiting_sheet",
                    "Arguments": objArgs,
                    "ReportName": "Visit_Report",
                    "PageOrientation": "Landscape"
                };

                //var url = '/ExportLoanReport/' + userid + '/'+ deliveryManId + '/' + startdate + '/' + enddate + '/' + new Date().getTimezoneOffset();
                $http.post(APP_CONSTANTS.backend + 'report/ReportPDF' , filters , { responseType: 'arraybuffer' })
                    .success(function (data) {
                        var file = new Blob([data], { type: 'application/pdf' });
                        saveAs(file, 'VisitingSheet.pdf');
                    });
            }

            Report.GridColumns = [


                {
                    field: "NVRV",
                    title: "NVRV",
                    type: "text",
                        //  width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[VisitReportCtrl.formatColumnName('statestartdate')]}}</span>",
                    headerTemplate: "<span>NV/RV</span>"
                },
                {
                    field: "LoanApplicationNumber",
                    title: "LoanApplicationNumber",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[VisitReportCtrl.formatColumnName('statestartdate')]}}</span>",
                    headerTemplate: "<span>Loan Application Number</span>"
                },
                {
                    field: "LoginDate",
                    title: "LoginDate",
                    type: "date",
                    format: "{0:dd MMM yyyy    hh:mm:ss}",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[VisitReportCtrl.formatColumnName('statestartdate')]}}</span>",
                    headerTemplate: "<span>Login Date</span>"
                },
                {
                    field: "ReturnDate",
                    title: "ReturnDate",
                    type: "date",
                    format: "{0:dd MMM yyyy    hh:mm:ss}",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[VisitReportCtrl.formatColumnName('statestartdate')]}}</span>",
                    headerTemplate: "<span>Return Date</span>"
                },
                {
                    field: "Name",
                    title: "Name",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[VisitReportCtrl.formatColumnName('statestartdate')]}}</span>",
                    headerTemplate: "<span>Name</span>"
                },
                {
                    field: "CompanyName",
                    title: "CompanyName",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[VisitReportCtrl.formatColumnName('statestartdate')]\}\}</span>",
                    headerTemplate: "<span>Company Name</span>"
                },
                {
                    field: "Area",
                    title: "Area",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[VisitReportCtrl.formatColumnName('statestartdate')]}}</span>",
                    headerTemplate: "<span>Area</span>"
                },
                {
                    field: "PhyRes",
                    title: "PhyRes",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[VisitReportCtrl.formatColumnName('statestartdate')]}}</span>",
                    headerTemplate: "<span>Phy Res</span>"
                },
                {
                    field: "PhyOff",
                    title: "PhyOff",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[VisitReportCtrl.formatColumnName('statestartdate')]}}</span>",
                    headerTemplate: "<span>Phy Off</span>"
                },
                {
                    field: "PaySlip",
                    title: "PaySlip",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[VisitReportCtrl.formatColumnName('statestartdate')]}}</span>",
                    headerTemplate: "<span>Pay Slip</span>"
                },                
                {
                    field: "ToState",
                    title: "ToState",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[VisitReportCtrl.formatColumnName('statestartdate')]}}</span>",
                    headerTemplate: "<span>To State</span>"
                },                
                {
                    field: "BS",
                    title: "BS",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[VisitReportCtrl.formatColumnName('BS')]}}</span>",
                    headerTemplate: "<span>B/s</span>"
                },
                {
                    field: "OtherDocs",
                    title: "OtherDocs",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[VisitReportCtrl.formatColumnName('OtherDocs')]}}</span>",
                    headerTemplate: "<span>Other Docs</span>"
                },
                {
                    field: "Status",
                    title: "Status",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[VisitReportCtrl.formatColumnName('Status')]}}</span>",
                    headerTemplate: "<span>Status</span>"
                },
                {
                    field: "KM",
                    title: "KM",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[VisitReportCtrl.formatColumnName('KM')]}}</span>",
                    headerTemplate: "<span>K.M</span>"
                },
                {
                    field: "Remarks",
                    title: "Remarks",
                    type: "text",
                    // width: $mdMedia('gt-sm') ? '10%' : '150px',
                    scrollable: false,
                    search: true,
                    template: "<span >{{dataItem[VisitReportCtrl.formatColumnName('Remarks')]}}</span>",
                    headerTemplate: "<span>Remarks</span>"
                }
            ];


            return Report;

        }]);
})();